/** Standard CSS px per mm at 96 DPI */
export const MM_TO_PX = 96 / 25.4;

/** PowerPoint widescreen 16:9 slide width (mm) */
export const WIDESCREEN_PAGE_WIDTH_MM = 339;

/** PowerPoint widescreen 16:9 slide height (mm) */
export const WIDESCREEN_PAGE_HEIGHT_MM = 190;

export function mmToPx(mm) {
  return Math.round(Number(mm) * MM_TO_PX);
}

export function pxToMm(px) {
  return Number(px) / MM_TO_PX;
}

/**
 * Layout metrics for embedding html2canvas captures into a jsPDF page.
 */
export function getPdfContentLayout(pdf, options = {}) {
  const marginMm = options.marginMm ?? 15;
  const contentTopMm = options.contentTopMm ?? 28;
  const bottomReserveMm = options.bottomReserveMm ?? 12;

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const contentWidthMm = pageWidth - 2 * marginMm;
  const contentWidthPx = mmToPx(contentWidthMm);

  return {
    pageWidth,
    pageHeight,
    marginMm,
    contentWidthMm,
    contentWidthPx,
    contentTopMm,
    bottomReserveMm,
  };
}

/**
 * Compare cover image aspect ratio to page aspect ratio (for dev warnings).
 */
export function aspectRatioMismatch(imageWidth, imageHeight, pageWidthMm, pageHeightMm, tolerance = 0.01) {
  if (!imageWidth || !imageHeight || !pageWidthMm || !pageHeightMm) return false;
  const imageAspect = imageWidth / imageHeight;
  const pageAspect = pageWidthMm / pageHeightMm;
  return Math.abs(imageAspect - pageAspect) / pageAspect > tolerance;
}
